export enum CountryConfigTypeEnum {
  Setup = 'setup',
  Calculator = 'calculator',
  Website = 'website',
  Validators = 'validators',
  Settings = 'settings',
  Socials = 'socials',
}
